import { ZERO } from './const.js';

export function isNegative(value: number) {
  return value < ZERO;
}
